import { ITicker, Network } from '@kattana-io/common';
import BigNumber from 'bignumber.js';
import ElrondSwap from './ElrondSwap';
import EvmSwap from './EvmSwap';
import { EOverlays, ETabs, ICoin } from '../../../reducers/dex/tradingReducer';
import { getNetworkFlags } from '../../../../../wallet/helpers';
import { OnRefresh } from '../../../../../wallet/walletContext';
import TonSwap from './TonSwap';
import { networksBySym } from '../../../../NetworkSelector/core';

export interface ISwapProps {
  current: ITicker;
  tab: ETabs;
  setTab: (val: ETabs) => void;
  setOverlay: (overlay: EOverlays) => void;
  network: Network;
  chainId: number;
  base: ICoin;
  quote: ICoin;
  meta?: ITicker;
  account: string | undefined;
  balancesAddress: any;
  ratesAddress: any;
  onFlip: () => void;
  onSetBaseAmount: (input: BigNumber) => void;
  onSetQuoteAmount: (input: BigNumber) => void;
  onNotify: (input: any) => void;
  onWalletRefresh: OnRefresh;
  setSlippage: (val: number) => void;
  slippage: number;
}

const Swap = (props: ISwapProps) => {
  const { isEVM, isElrond, isTon } = getNetworkFlags(props.network.toDecimal());
  const baseCoinNetwork = getNetworkFlags(
    networksBySym[props.base.chain]?.toDecimal()
  );

  if (isEVM || baseCoinNetwork.isEVM) {
    return <EvmSwap {...props} />;
  }

  if (isElrond || baseCoinNetwork.isElrond) {
    return <ElrondSwap {...props} />;
  }

  if (isTon || baseCoinNetwork.isTon) {
    return <TonSwap {...props} />;
  }

  return <div></div>;
};

export default Swap;
